import type { AiBriefInstructionStatus } from '@apis/aiAgent';

/** Whether a status has anything to say. */
export function hasNotes(status: AiBriefInstructionStatus): boolean {
  return (
    status.unsupported.length > 0 ||
    status.mutedConflicts.length > 0 ||
    status.unknownFloor !== null ||
    status.expiredOn !== null ||
    status.startsOn !== null
  );
}
